import { Api } from '@axiom/ui';
import type { Experience, ExperienceEdit } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class ExperiencesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async updateExperience(
    experienceId: Experience['id'],
    body: Partial<ExperienceEdit>
  ) {
    return super.write<{ data: Experience }>({
      endpoint: `/experiences/${experienceId}`,
      body,
      method: 'PATCH',
    });
  }

  async deleteExperience(experienceId: Experience['id']) {
    return super.write<{ data: Experience }>({
      endpoint: `/experiences/${experienceId}`,
      method: 'DELETE',
    });
  }
}

export const ExperiencesApi = new ExperiencesApiClass();
